import { requestGooseAPI, getAPIPath } from '../shared/request'
import { UserClientDto } from '../types'
import { CLIENT_USER_PATH } from '../types/constants'

export const ClientUserService = {
  get: async (locationId: string, userId: string) => {
    return requestGooseAPI<UserClientDto>({
      url: getAPIPath(CLIENT_USER_PATH, { locationId: locationId, id: userId }),
      method: 'GET',
      params: {
        includes: ['userProfile'],
      },
    })
  },
}
